import { Component, inject } from '@angular/core';
import { CheckoutWrapperComponent } from 'gung-standard';
import { first } from 'rxjs';
import { OttoOlsenCheckoutConfigService } from '../../../services/otto-olsen-checkout-config.service';

@Component({
    selector: 'otto-olsen-checkout-wrapper',
    templateUrl: './otto-olsen-checkout-wrapper.component.html',
    styleUrls: ['./otto-olsen-checkout-wrapper.component.scss'],
    standalone: false
})
export class OttoOlsenCheckoutWrapperComponent extends CheckoutWrapperComponent {
  isDemoAccount: boolean = false;
  protected checkoutConfig = inject(OttoOlsenCheckoutConfigService)

  constructor() {
    super()
 
    this.authService.getRoles().subscribe(roles => {
      this.isDemoAccount = roles.indexOf('DEMO') > -1;
    });
  }

  createOffer() {
    if (this.isDemoAccount) {
      this.demoSubmitOrder();
      return;
    }
    super.createOffer();
  }

  protected submitOrder() {
    if (this.isDemoAccount) {
      this.demoSubmitOrder();
      return;
    }
    super.submitOrder();
  }

  demoSubmitOrder() {
    this.cartKeyService.getCurrentCartKey().pipe(first()).subscribe(key => {
      localStorage.removeItem(key);
      this.cartService.clearCart();
      this.router.navigate(['/demo/checkout/']);
    });
  }

  public hasUnsavedChanges(): boolean {
    return this.checkoutConfig.hasUnsavedChanges;
  }
}
